import { isFeatureEnabled } from 'owa-feature-flags';

import celebrateSvgV1 from '../resources/v1/celebrate.svg';
import celebrateJsonV1 from '../resources/v1/celebrate.json';
import heartSvgV1 from '../resources/v1/heart.svg';
import heartJsonV1 from '../resources/v1/heart.json';
import laughSvgV1 from '../resources/v1/laugh.svg';
import laughJsonV1 from '../resources/v1/laugh.json';
import likeSvgV1 from '../resources/v1/like.svg';
import likeJsonV1 from '../resources/v1/like.json';
import sadSvgV1 from '../resources/v1/sad.svg';
import sadJsonV1 from '../resources/v1/sad.json';
import surprisedSvgV1 from '../resources/v1/surprised.svg';
import surprisedJsonV1 from '../resources/v1/surprised.json';

import celebrateSvgV2 from '../resources/v2/celebrate.svg';
import celebrateJsonV2 from '../resources/v2/celebrate.json';
import heartSvgV2 from '../resources/v2/heart.svg';
import heartJsonV2 from '../resources/v2/heart.json';
import laughSvgV2 from '../resources/v2/laugh.svg';
import laughJsonV2 from '../resources/v2/laugh.json';
import likeSvgV2 from '../resources/v2/like.svg';
import likeJsonV2 from '../resources/v2/like.json';
import sadSvgV2 from '../resources/v2/sad.svg';
import sadJsonV2 from '../resources/v2/sad.json';
import surprisedSvgV2 from '../resources/v2/surprised.svg';
import surprisedJsonV2 from '../resources/v2/surprised.json';

const ANIMATED_REACTION_RESOURCES_V1 = {
    celebrate: celebrateJsonV1,
    heart: heartJsonV1,
    laugh: laughJsonV1,
    like: likeJsonV1,
    sad: sadJsonV1,
    surprised: surprisedJsonV1,
};

const STATIC_REACTION_RESOURCES_V1 = {
    celebrate: celebrateSvgV1,
    heart: heartSvgV1,
    laugh: laughSvgV1,
    like: likeSvgV1,
    sad: sadSvgV1,
    surprised: surprisedSvgV1,
};

const ANIMATED_REACTION_RESOURCES_V2 = {
    celebrate: celebrateJsonV2,
    heart: heartJsonV2,
    laugh: laughJsonV2,
    like: likeJsonV2,
    sad: sadJsonV2,
    surprised: surprisedJsonV2,
};

const STATIC_REACTION_RESOURCES_V2 = {
    celebrate: celebrateSvgV2,
    heart: heartSvgV2,
    laugh: laughSvgV2,
    like: likeSvgV2,
    sad: sadSvgV2,
    surprised: surprisedSvgV2,
};

export default function getReactionResourceData(
    reactionType: string,
    isAnimated: boolean
): any | null {
    const use3DAssets = isFeatureEnabled('tri-3D-reactions');
    return (
        (isAnimated
            ? getAnimatedReactionResources(use3DAssets)
            : getStaticReactionResources(use3DAssets))[reactionType] ?? null
    );
}

const getAnimatedReactionResources = (use3DAssets: boolean) => {
    return use3DAssets ? ANIMATED_REACTION_RESOURCES_V2 : ANIMATED_REACTION_RESOURCES_V1;
};

const getStaticReactionResources = (use3DAssets: boolean) => {
    return use3DAssets ? STATIC_REACTION_RESOURCES_V2 : STATIC_REACTION_RESOURCES_V1;
};
